export const sampleCsvData = [
  {
    order_number: 1234,
    channel: 'shopify *REQUIRED*',
    product_cost: 19.99,
    gateway_fee: 2.99,
    backcharges_cost: 3.99,
    shipping_cost: 5.27,
    shipping_label_cost: 2.99,
    shipping_provider: 'usps',
    tracking_number: '1Z999AA19123456789',
    meta_data: "{ sampleMetaInfo1: 'leave columns blank if unused' }"
  },
  { // partial update
    order_number: 1235,
    shipping_cost: 8.50,
    backcharges_cost: 2.25,
    tracking_number: '1Z999AA19123456790'
  }
]

export const sampleCsvHeaders = [
  { label: 'order_number', key: 'order_number' },
  { label: 'channel', key: 'channel' },
  { label: 'product_cost', key: 'product_cost' },
  { label: 'gateway_fee', key: 'gateway_fee' },
  { label: 'backcharges_cost', key: 'backcharges_cost' },
  { label: 'shipping_label_cost', key: 'shipping_label_cost' },
  { label: 'shipping_cost', key: 'shipping_cost' },
  { label: 'shipping_provider', key: 'shipping_provider' },
  { label: 'tracking_number', key: 'tracking_number' },
  { label: 'meta_data', key: 'meta_data' },
]

export const ACCEPTED_HEADERS = sampleCsvHeaders.map(header => header.label)

/**
 * All possible headers that can be uploaded
 */
export const ALL_POSSIBLE_HEADERS = sampleCsvHeaders.map(header => header.label)

/**
 * Only order_number is truly required for partial upserts
 */
export const REQUIRED_HEADERS = ['order_number']

/**
 * For new record creation, channel is also required
 */
export const REQUIRED_HEADERS_FOR_NEW_RECORDS = ['order_number', 'channel']

export const sanitizeData = (data) => {
  return data.map((row) => {
    return Object.keys(row).reduce((obj, key) => {
      obj[key] = typeof row[key] === 'string' ? row[key].replace(/[^A-Za-z0-9.@_-{}:,"]/g, '') : row[key]
      return obj
    }, {})
  })
}

export const checkFileSize = (data) => {
  const sizeInBytes = new TextEncoder().encode(JSON.stringify(data)).length
  return sizeInBytes
}

export const checkInvalidProperties = (data) => {
  if (!data || data.length === 0) return ['No data found']
  
  const dataProperties = Object.keys(data[0])
  const missingRequiredProperties = REQUIRED_HEADERS.filter(prop => !dataProperties.includes(prop))
  
  const invalidProperties = dataProperties.filter(prop => !ALL_POSSIBLE_HEADERS.includes(prop))
  
  return [...missingRequiredProperties, ...invalidProperties]
}

export const checkInvalidSheetsProperties = (data) => {
  if (!data || data.length === 0) return ['No data found']
  
  const dataProperties = Object.keys(data[0])
  const missingRequiredProperties = REQUIRED_HEADERS_FOR_NEW_RECORDS.filter(prop => !dataProperties.includes(prop))
  
  const invalidProperties = dataProperties.filter(prop => !ALL_POSSIBLE_HEADERS.includes(prop))
  
  return [...missingRequiredProperties, ...invalidProperties]
}

export const validatePartialUpdateData = (data) => {
  if (!data || data.length === 0) return ['No data found']
  
  const dataProperties = Object.keys(data[0])
  const missingOrderNumber = !dataProperties.includes('order_number')
  
  if (missingOrderNumber) {
    return ['order_number is required for all partial updates']
  }
  
  const invalidProperties = dataProperties.filter(prop => !ALL_POSSIBLE_HEADERS.includes(prop))
  
  return invalidProperties
}